import React, { createContext, useContext, useState } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(true);

  const toggleTheme = () => {
    setIsDarkMode(prev => !prev);
  };

  const theme = {
    isDarkMode,
    colors: isDarkMode ? {
      background: '#111111',
      surface: 'linear-gradient(to right, #1a1a1a, #262626)',
      surfaceHover: 'linear-gradient(135deg, #1a1a1a, #262626)',
      text: '#ffffff',
      textSecondary: 'rgba(255, 255, 255, 0.7)',
      border: 'rgba(255, 255, 255, 0.1)',
      borderHover: 'rgba(255, 255, 255, 0.2)',
      accent: '#4CAF50',
      accentHover: '#3d8b40',
      accentTransparent: 'rgba(76, 175, 80, 0.1)',
      buttonBackground: '#1e1e1e',
      buttonBackgroundHover: '#2a2a2a',
      buttonText: '#0099ff',
      buttonBorder: '#333333'
    } : {
      background: '#ffffff',
      surface: '#ffffff',
      surfaceHover: '#f8f9fa',
      text: '#1a1a1a',
      textSecondary: '#4a4a4a',
      border: '#e1e4e8',
      borderHover: '#d0d7de',
      accent: '#0066cc',
      accentHover: '#0052a3',
      accentTransparent: 'rgba(0, 102, 204, 0.1)',
      cardBackground: '#ffffff',
      cardBorder: '#e1e4e8',
      cardShadow: '0 1px 3px rgba(0, 0, 0, 0.04)',
      buttonBackground: '#f8f9fa',
      buttonBackgroundHover: '#f1f3f5',
      buttonText: '#1a1a1a',
      buttonBorder: '#e1e4e8'
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}; 